import { Component, inject } from "@angular/core";
import { HeaderDialogComponent } from "../../modules/dialog/header-dialog/header-dialog.component";
import { MatDialogRef } from "@angular/material/dialog";
import { TranslateUtils } from "../../utils/translate.utils";
import { JustLogoComponent } from "../just-logo/just-logo.component";

@Component({
  selector: "vl-generate-pdf-loader",
  standalone: true,
  imports: [HeaderDialogComponent, JustLogoComponent],

  templateUrl: "./generate-pdf-loader.component.html",
  styleUrl: "./generate-pdf-loader.component.scss",
})
export class GeneratePdfLoaderComponent {
  dialogRef = inject(MatDialogRef<GeneratePdfLoaderComponent>);

  generating = TranslateUtils.translate("pdf.generate");
}
